import { useHistory } from "react-router-dom";
import { Form, Input, message, Button, Select } from "antd";
import { updateOne } from "../../../api/user";
import { formLayout } from "../../../utils/constants";
import NewPassword from "./NewPassword";

const { Option } = Select;

function EditUser({ user, closeModal, setModalContent }) {
  const history = useHistory();

  const onFinish = (values) => {
    sendDataToServer(values);
  };

  // ------ Actualiza usuario ------
  const sendDataToServer = async (data) => {
    try {
      const response = await updateOne(data, user._id);
      message.success(response.message);
      history.replace("/app/usuarios");
      window.location.reload();
      closeModal();
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  // ----- muestra componente para cambiar contraseña -----
  const showNewPassword = () => {
    setModalContent(
      <NewPassword userId={user._id} firstName={user.firstName} closeModal={closeModal} />
    );
  };

  return (
    <Form
      {...formLayout.formItemLayout}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label="Usuario"
        name="username"
        initialValue={user.username}
        rules={[
          {
            required: true,
            message: "El campo usuario es necesario"
          }
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Número de DNI"
        name="documentNumber"
        initialValue={user.documentNumber}
        rules={[
          {
            required: true,
            message: "El campo DNI es necesario"
          },
          {
            len: 8,
            message: "El valor debe tener 8 caracteres"
          }
        ]}
      >
        <Input type="number" />
      </Form.Item>

      <Form.Item
        label="Nombres"
        name="firstName"
        initialValue={user.firstName}
        rules={[{ required: true, message: "El nombre es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Apellidos"
        name="lastName"
        initialValue={user.lastName}
        rules={[{ required: true, message: "El apellido es necesario" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Correo electrónico" name="email" initialValue={user.email}>
        <Input type="email" />
      </Form.Item>

      <Form.Item label="Número de celular" name="phoneNumber" initialValue={user.phoneNumber}>
        <Input />
      </Form.Item>

      {/* <Form.Item
        label="Nombre para asignar"
        name="nameToAssign"
        rules={[
          { required: true, message: "El nombre para asignar es necesario" },
        ]}
        initialValue={user.nameToAssign}
      >
        <Input />
      </Form.Item> */}

      <Form.Item
        label="Rol"
        name="role"
        initialValue={user.role}
        rules={[{ required: true, message: "El rol es necesario" }]}
      >
        <Select>
          <Option value="organizer">Organizador</Option>
          <Option value="admin">Administrador</Option>
        </Select>
      </Form.Item>

      <Form.Item {...formLayout.tailFormItemLayout}>
        <Button type="link" block onClick={showNewPassword}>
          Actualizar contraseña
        </Button>
      </Form.Item>

      <Form.Item {...formLayout.tailFormItemLayout}>
        <Button type="primary" block htmlType="submit">
          Actualizar usuario
        </Button>
      </Form.Item>
    </Form>
  );
}

export default EditUser;
